import { render } from "./Profile.vue?vue&type=template&id=167bf05b&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=167bf05b&scoped=true&lang=css"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167bf05b"]])

export default __exports__